import { render } from "./fhpx.vue?vue&type=template&id=7421a96f&scoped=true&ts=true"
import script from "./fhpx.vue?vue&type=script&lang=ts"
export * from "./fhpx.vue?vue&type=script&lang=ts"

import "./fhpx.vue?vue&type=style&index=0&id=7421a96f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7421a96f"]])

export default __exports__